"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const FeatureDemo_1 = tslib_1.__importDefault(require("../../Anyone/FeatureDemo"));
const react_router_dom_1 = require("react-router-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
exports.AdsManagerPreview = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, null,
            react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginLeft: true },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/ads/manager", className: "text-reset" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowAltSquareLeft }),
                        " Back")),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true },
                    react_1.default.createElement("h1", { className: "text-center" }, "Ads Manager Feature Preview")),
                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true, marginRight: true, style: { opacity: 0 } },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/ads/manager" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowAltSquareLeft }),
                        " Back"))),
            react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true, padding: true, style: { maxWidth: 1200, width: '100%' }, className: "mx-auto" },
                react_1.default.createElement(FeatureDemo_1.default, { usecase: "ads", allowUsecaseChange: false, showHeader: false })))));
};
exports.default = exports.AdsManagerPreview;
//# sourceMappingURL=index.js.map